import React from "react";

export const Header = (props) => {
  const whatsappNumber = props.whatsapp
    ? props.whatsapp.replace(/\D/g, "")
    : "917517312557";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    "Hello AstroSarathi, I would like to get updates about the upcoming webinar."
  )}`;

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <img className="page-scroll" src={props?.data?.brnadLogo} width="300" height="300" alt="brandlogo"/>
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                <a
                  href={whatsappLink}
                  className="btn btn-custom btn-lg page-scroll"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Join Webinar Updates !!
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
